/* eslint-disable security/detect-object-injection */
import React from 'react';
import { useI18n } from 'nordic/i18n';
import { Button } from '@andes/button';
import { ui } from '@credits-utils/constants';
import { Typography } from '@andes-landings/typography';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getHeroSectionContent } from '../../content/heroSection';
import { Hero } from '../../../../../components/Hero';

const { TYPOGRAPHY } = ui;

const HeroSection = () => {
  const {
    deviceType,
    isMobile,
    isYellowTheme,
  } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const {
    title,
    subtitle,
    buttonText,
    backgroundImages,
  } = getHeroSectionContent({ i18n });

  return (
    <Hero
      backgroundImage={(backgroundImages && backgroundImages[deviceType]) && backgroundImages[deviceType]}
      isMobile={isMobile}
    >
      <div className="hero-section ">
        <div className="hero-section__title">{title.toUpperCase()}</div>
        <Typography
          component={TYPOGRAPHY.COMPONENT.H1}
          type="hero"
          color={!isYellowTheme && TYPOGRAPHY.COLOR.INVERTED}
        >
          {subtitle.toUpperCase()}
        </Typography>
        <Button className={!isYellowTheme && 'andes-button--white'} href="#marketing-section">
          { buttonText }
        </Button>
      </div>
    </Hero>
  );
};

export default HeroSection;
